import React from 'react';
import { useCheckAuth } from '../hooks/useCheckAuth';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

export function RequireAuth({ children }) {
  const { isLoggedIn, isLoading } = useCheckAuth();

  if (!isLoggedIn && !isLoading) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

RequireAuth.propTypes = {
  children: PropTypes.node.isRequired,
};
